import React from "react";
import { useRemotePromos } from "src/ssc-api/useRemotePromos";
import { OffersMosaic } from "components/OffersMosaic/OffersMosaic";
import {
  BackgroundColor,
  MosaicLayoutProps
} from "@silversea-ssc/ui-components-react";
import {
  filterByVisibility,
  OffersVisibility
} from "src/utils/offerVisibilityHelper";
import { isPresent } from "src/utils/checks";
import { CollectionMosaicExclusiveOfferPerPromoFragment } from "types/graphql-types";
import { mergeOffersStaticContentWithRemote } from "src/utils/promos";

interface OffersCollectionMosaicProps extends MosaicLayoutProps {
  offersVisibility?: undefined | OffersVisibility;
  cardBackgroundColor: BackgroundColor;
  data: CollectionMosaicExclusiveOfferPerPromoFragment[];
}

const OffersCollectionMosaic: React.FC<
  React.PropsWithChildren<OffersCollectionMosaicProps>
> = ({ offersVisibility = "hideOffersCollection", data = [], ...props }) => {
  const filteredOffers =
    (offersVisibility
      ? filterByVisibility(data, offersVisibility)
      : data
    )?.filter(isPresent) || [];
  const { data: dynamicData } = useRemotePromos();

  const mergedData = mergeOffersStaticContentWithRemote(
    filteredOffers,
    dynamicData
  );

  return <OffersMosaic {...props} data={mergedData}></OffersMosaic>;
};

export default OffersCollectionMosaic;
